import { Link } from "react-router-dom";
import { withLayout } from "../../components/feature/PageLayout";
import SEOHead from "../../components/feature/SEOHead";

const siteUrl = (import.meta.env.VITE_SITE_URL || "").replace(/\/+$/, "");

function Home() {
  return (
    <>
      <SEOHead
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "香氛女王的幸福大地",
          "alternateName": "Aroma Wealth Queen",
          "description": "以芳香療癒、創富系統與領導培訓，陪伴女性照顧家庭健康、學習自我成長，探索屬於自己的彈性收入與自由人生。",
          "url": `${siteUrl}/`,
          "logo": "https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/9aa924cb31af5202bbd782f0a24da659.png",
          "sameAs": [
            "https://line.me/R/ti/p/@your-id",
            "https://www.facebook.com/groups/your-group",
            "https://www.instagram.com/your-handle",
            "https://www.youtube.com/@your-handle",
            "https://www.tiktok.com/@your-handle",
            "https://www.threads.net/@your-handle"
          ]
        }}
      />
      {/* Hero Section */}
      <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20soft%20golden%20light%20aroma%20therapy%20scene%20with%20elegant%20essential%20oil%20bottles%20on%20a%20minimal%20marble%20surface%2C%20delicate%20white%20flowers%20and%20eucalyptus%20leaves%2C%20soft%20natural%20sunlight%20creating%20gentle%20shadows%2C%20feminine%20warm%20amber%20aesthetic%2C%20luxurious%20spa%20atmosphere%2C%20cream%20and%20beige%20tones%2C%20high%20quality%20product%20photography%20with%20creamy%20bokeh%20background%2C%20elegant%20composition%20with%20negative%20space%20on%20the%20right&width=1800&height=900&seq=home-hero-bg-01&orientation=landscape"
          alt="香氛女王的幸福大地 - 芳香療癒品牌形象"
          title="香氛女王的幸福大地 芳香療癒品牌形象"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30"></div>
        <div className="relative z-10 w-full max-w-[1120px] mx-auto px-4 md:px-6 text-center">
          <h1 className="text-[2rem] md:text-[2.75rem] font-bold text-white leading-[1.3] mb-3 md:mb-4">
            讓香氣，帶你遇見更好的自己與人生
          </h1>
          <p className="text-[1.1875rem] text-white/80 leading-[1.75] max-w-[720px] mx-auto mb-5 md:mb-6">
            身心靈財富整合女王｜香氣創富導師。以芳香療癒 × 創富系統 ×
            領導培訓，協助女性守護家庭健康，並探索屬於自己的彈性收入與自由人生。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://line.me/R/ti/p/@your-id"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center justify-center px-7 py-3 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200"
            >
              立即加入 LINE@
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-7 py-3 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer border-2 border-white text-white hover:bg-white/15 transition-colors duration-200"
            >
              預約免費諮詢
            </Link>
          </div>
        </div>
      </section>

      {/* Brand Essence Section */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-[1120px] mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
            {/* Left text */}
            <div className="lg:w-[40%]">
              <span className="inline-block text-[1rem] font-medium text-foreground-600 bg-background-200/70 rounded-full px-4 py-1.5 mb-4">
                Brand Essence
              </span>
              <h2 className="text-[1.5rem] md:text-[2.125rem] font-bold text-foreground-950 leading-[1.4] mb-5">
                品牌宣言 Brand Essence
              </h2>
              <p className="text-[1.1875rem] text-foreground-600 leading-[1.75] mb-4">
                我相信，香氣不只是味道，它能陪伴身心，也能開啟一個人重新理解自己、照顧家庭與創造選擇的力量。
              </p>
            </div>
            {/* Right cards */}
            <div className="lg:w-[60%]">
              <div className="bg-secondary-500 rounded-[18px] p-6 md:p-8">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                  {[
                    {
                      title: "療癒自己",
                      desc: "芳香精油帶來身心平衡的日常陪伴，從照顧自己開始，重新建立內在穩定。",
                    },
                    {
                      title: "幫助他人",
                      desc: "學會用香氣與生活經驗分享，協助更多人成為家庭健康與生活品質的守護者。",
                    },
                    {
                      title: "創造自由",
                      desc: "透過可學習、可複製的芳香創富系統，建立屬於自己的女性事業節奏。",
                    },
                  ].map((item) => (
                    <div key={item.title}>
                      <h3 className="text-[1.25rem] md:text-[1.5rem] font-semibold text-white mb-2.5">
                        {item.title}
                      </h3>
                      <p className="text-[1rem] text-white/75 leading-[1.7]">
                        {item.desc}
                      </p>
                    </div>
                  ))}
                </div>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 mt-6 text-[1rem] text-white/85 hover:text-white transition-colors duration-200 cursor-pointer"
                >
                  了解更多 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Three Core Values */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-[1120px] mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-12 gap-3">
            <h2 className="text-[1.5rem] md:text-[2.125rem] font-bold text-foreground-950 leading-[1.4]">
              三大核心價值
            </h2>
            <p className="text-[1rem] text-foreground-600 max-w-[400px]">
              香氣療癒 × 創富系統 ×
              領導培訓，三個維度完整支持妳的成長旅程
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-7">
            {[
              {
                title: "香氣療癒",
                desc: "以芳香生活與身心靈實務結合，幫助人們在日常中找到放鬆、安定與照顧自己的方式。",
                image: "https://readdy.ai/api/search-image?query=Elegant%20essential%20oil%20diffuser%20on%20a%20minimal%20wooden%20nightstand%20with%20soft%20ambient%20lighting%2C%20white%20cotton%20bedding%20in%20background%2C%20delicate%20dried%20lavender%20and%20eucalyptus%20branches%2C%20warm%20golden%20hour%20light%20streaming%20through%20sheer%20curtains%2C%20cozy%20feminine%20bedroom%20aesthetic%2C%20cream%20and%20beige%20tones%2C%20lifestyle%20photography%20with%20soft%20focus%20and%20dreamy%20atmosphere&width=800&height=600&seq=home-value-01&orientation=landscape",
              },
              {
                title: "創富系統",
                desc: "從零開始建立可複製的行動流程：心態調頻 → 精油應用 → 分享話術 → 團隊複製。",
                image: "https://readdy.ai/api/search-image?query=Modern%20minimal%20workspace%20with%20a%20woman%20writing%20in%20a%20beautiful%20leather%20journal%2C%20essential%20oil%20bottles%20and%20dried%20flowers%20on%20desk%2C%20warm%20natural%20lighting%20from%20window%2C%20elegant%20feminine%20entrepreneur%20aesthetic%2C%20gold%20and%20cream%20color%20palette%2C%20organized%20and%20peaceful%20atmosphere%2C%20lifestyle%20business%20photography%20with%20soft%20shadows&width=800&height=600&seq=home-value-02&orientation=landscape",
              },
              {
                title: "領導培訓",
                desc: "以系統與文化培育未來領袖，讓團隊夥伴被支持、被看見，也能逐步帶領更多人。",
                image: "https://readdy.ai/api/search-image?query=Warm%20intimate%20group%20workshop%20setting%20with%20women%20sitting%20in%20a%20circle%2C%20essential%20oils%20and%20notebooks%20on%20a%20low%20wooden%20table%2C%20soft%20natural%20light%20from%20large%20windows%2C%20peaceful%20and%20supportive%20atmosphere%2C%20cream%20and%20warm%20beige%20tones%2C%20coaching%20and%20mentoring%20vibe%2C%20feminine%20empowerment%20photography%20with%20gentle%20bokeh&width=800&height=600&seq=home-value-03&orientation=landscape",
              },
            ].map((item) => (
              <div
                key={item.title}
                className="bg-white rounded-[18px] overflow-hidden shadow-[0_2px_16px_rgba(0,0,0,0.06)]"
              >
                <div className="w-full h-[220px] md:h-[260px] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={item.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <h3 className="text-[1.25rem] md:text-[1.625rem] font-semibold text-foreground-950 leading-[1.5] mb-2.5">
                    {item.title}
                  </h3>
                  <p className="text-[1.1875rem] text-foreground-600 leading-[1.75]">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Brand Video Section */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-[1120px] mx-auto px-4 md:px-6 text-center">
          <h2 className="text-[1.5rem] md:text-[2.125rem] font-bold text-foreground-950 leading-[1.4] mb-3">
            品牌形象影片
          </h2>
          <p className="text-[1.1875rem] text-foreground-600 leading-[1.75] mb-8">
            60 秒短片：「我的故事 × 團隊精神 × 創富理念」
          </p>
          <div className="relative w-full max-w-[800px] mx-auto aspect-video rounded-[18px] overflow-hidden shadow-[0_2px_16px_rgba(0,0,0,0.08)] bg-background-200/70">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center">
                <div className="w-16 h-16 md:w-20 md:h-20 mx-auto mb-3 rounded-full bg-primary-500/20 flex items-center justify-center cursor-pointer">
                  <i className="ri-play-fill text-[2rem] md:text-[2.5rem] text-primary-500"></i>
                </div>
                <p className="text-[1rem] text-foreground-600">
                  YouTube 影片嵌入區
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Short Videos */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-[1120px] mx-auto px-4 md:px-6">
          <div className="mb-10 md:mb-12">
            <h2 className="text-[1.5rem] md:text-[2.125rem] font-bold text-foreground-950 leading-[1.4] mb-2">
              最新短影音／成功案例
            </h2>

          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {[
              {
                title: "【我的起點】從芳香到財富自由",
                sub: "30–60 秒｜品牌故事",
                image: "https://readdy.ai/api/search-image?query=Soft%20warm%20lighting%20on%20a%20woman%20gently%20holding%20an%20essential%20oil%20bottle%2C%20close%20up%20of%20hands%20and%20beautiful%20glass%20bottle%20with%20golden%20liquid%2C%20cream%20background%20with%20soft%20bokeh%2C%20feminine%20self%20care%20aesthetic%2C%20warm%20amber%20and%20beige%20tones%2C%20cinematic%20lifestyle%20photography&width=600&height=450&seq=home-video-01&orientation=landscape",
              },
              {
                title: "香氣 × 創富的三步驟",
                sub: "心態 → 應用 → 複製",
                image: "https://readdy.ai/api/search-image?query=Clean%20minimal%20flat%20lay%20with%20essential%20oil%20bottles%2C%20a%20beautiful%20journal%20with%20handwritten%20notes%2C%20dried%20flowers%20and%20a%20cup%20of%20herbal%20tea%2C%20warm%20natural%20light%20from%20above%2C%20cream%20and%20gold%20color%20palette%2C%20lifestyle%20branding%20photography%20with%20elegant%20composition&width=600&height=450&seq=home-video-02&orientation=landscape",
              },
              {
                title: "她如何從 0 到第一筆收入",
                sub: "成功案例｜90 天行動",
                image: "https://readdy.ai/api/search-image?query=A%20woman%20smiling%20confidently%20in%20a%20bright%20airy%20room%2C%20essential%20oil%20display%20on%20a%20shelf%20behind%20her%2C%20warm%20natural%20lighting%2C%20casual%20elegant%20white%20blouse%2C%20empowered%20feminine%20portrait%2C%20cream%20walls%20and%20wooden%20accents%2C%20success%20and%20confidence%20vibe&width=600&height=450&seq=home-video-03&orientation=landscape",
              },
              {
                title: "領導不是掌控，是賦能",
                sub: "團隊文化｜6000 人",
                image: "https://readdy.ai/api/search-image?query=Group%20of%20women%20in%20a%20bright%20workshop%20space%20sharing%20and%20laughing%20together%2C%20essential%20oil%20bottles%20and%20materials%20on%20tables%2C%20warm%20natural%20light%20from%20windows%2C%20supportive%20community%20atmosphere%2C%20cream%20and%20beige%20interior%2C%20team%20spirit%20and%20empowerment%20photography&width=600&height=450&seq=home-video-04&orientation=landscape",
              },
            ].map((video) => (
              <div
                key={video.title}
                className="bg-white rounded-[18px] overflow-hidden shadow-[0_2px_12px_rgba(0,0,0,0.06)]"
              >
                <div className="w-full h-[180px] md:h-[200px] overflow-hidden">
                  <img
                    src={video.image}
                    alt={video.title}
                    title={video.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-[1.0625rem] md:text-[1.125rem] font-semibold text-foreground-950 leading-[1.5] mb-1.5">
                    {video.title}
                  </h3>
                  <p className="text-[1rem] text-foreground-600 leading-[1.6]">
                    {video.sub}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-16 md:py-24 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cozy%20aromatherapy%20lifestyle%20scene%20with%20soft%20candlelight%20and%20essential%20oil%20diffuser%20on%20a%20wooden%20table%2C%20plush%20cream%20throw%20blanket%20and%20dried%20flowers%2C%20gentle%20evening%20ambiance%2C%20golden%20amber%20and%20beige%20tones%2C%20luxurious%20spa%20atmosphere%2C%20cinematic%20soft%20focus%20with%20dreamy%20bokeh%20lights%2C%20self%20care%20and%20relaxation%20vibe&width=1800&height=700&seq=home-cta-bg&orientation=landscape"
          alt="芳香創富 CTA"
          title="芳香創富 立即加入"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
        <div className="relative z-10 max-w-[1120px] mx-auto px-4 md:px-6 text-center">
          <h2 className="text-[1.5rem] md:text-[2.125rem] font-bold text-white leading-[1.4] mb-3">
            想了解如何用芳香創富？
          </h2>
          <p className="text-[1.1875rem] text-white/80 leading-[1.75] mb-6">
            點我加入 LINE 官方社群
          </p>
          <a
            href="https://line.me/R/ti/p/@your-id"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200"
          >
            加入 LINE@ <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </section>
    </>
  );
}

export default withLayout(Home);